module.exports = __webpack_public_path__ + "static/media/marker-off-icon.e035be10.svg";